export default { sha: '0194c0dae3259c7dad6e6ebf2381786a9977c75c', buildNumber: 'undefined' }
